import * as React from "react"

import { AppSidebarContainer } from "../containers/AppSidebarContainer"
import { GlobalErrorHandler } from "@/app/et-components/modals/GlobalErrorHandler"
import { CompanyMetaContainer } from "../components/app/CompanyMetaContainer"
import { RouteComponentProps, withRouter } from '@/app/navigation/withRouter'
import { DirtyGuard } from '@/modules/shared/components/DirtyGuard'

type Props = {
    children?: React.ReactNode
}

const AppLayoutDahboardWithNavComponent = ({
    children,
    location,
} : Props & RouteComponentProps) => {
    const shouldHideSidebar = location.pathname.includes('/creator')

    return (
        <div className="tw-flex tw-min-h-screen !tw-bg-content-primary" data-test-id="LayoutDahboardWithNav">
            {!shouldHideSidebar && <AppSidebarContainer />}
       
            <div className="tw-flex tw-min-w-0 tw-flex-1 tw-overflow-x-auto">{children}</div>
            <GlobalErrorHandler />
            <CompanyMetaContainer />
            <DirtyGuard />
        </div>
    )
}

export const AppLayoutDahboardWithNav = withRouter(AppLayoutDahboardWithNavComponent)
